<template>
  <div>
    <nav-bread :page="{name:'feedAnalytics', title: $t('breadCrumbs.settings.title'), sub: $t('breadCrumbs.settings.sub')}"/>
    <el-tabs v-model="tabs.activeName" v-if="feedLoaded">
        <el-select class="small-screen" size="small" v-model="tabs.activeName">
          <el-option
            v-for="item in settings"
            :value="item.name"
            :label="item.title"
            :key="item.title"
            >
          </el-option>
        </el-select>
      <el-tab-pane v-for="tab in settings" :label="tab.title" :name="tab.name"  :key="tab.name" class="feed-settings-tab">
        <component :is="tab.name" :active="tab.name === tabs.activeName"></component>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
  /*
    feed settings children component
    use i18n locale
    see http://kazupon.github.io/vue-i18n/started.html for details
  */

  // tabs
  import Common from './tabs/Common';
  import Source from './tabs/Source';
  import ThreadUsers from './tabs/ThreadUsers';
  import StopSource from './tabs/StopSource';
  import MetaSource from './tabs/MetaSource';
  import Events from './tabs/Events';
  import NavBread from '@/components/navBread/NavBread';
  import Guides from './tabs/Guides';
  import Extended from './tabs/Extended';
  import Static from './tabs/Static';
  import Logi from './tabs/Logi';

  export default {
    name: 'Settings',
    data() {
      return {
        tabs: {
          activeName: 'Common',
        }
      };
    },
    computed: {
      feed() {
        return this.$store.getters['feed'](this.$route.params.threadId)
          ?
          this.$store.getters['feed'](this.$route.params.threadId)
          :
          [];
      },
      feedLoaded() {
        return Object.keys(this.feed).length;
      },
      isKeyWordType() {
        return this.feed.threadtype === 'keywords';
      },
      isSourceType() {
        return this.feed.threadtype === 'profiles';
      },
      settings() {
        let tabs;
        if (!this.feed.show_at_map) {
          tabs = this.$t('feedSettings').filter(item => item.name !== 'Events');
        } else {
          tabs = this.$t('feedSettings');
        }

        if (this.feed.uid != '1114' && this.feed.uid != '1074') {
          tabs = tabs.filter(item => item.name !== 'Logi');
        }
        
        if (!this.$store.getters.isAdmin) {
          tabs = tabs.filter(item => item.name !== 'Extended').filter(item => item.name !== 'ThreadUsers');
        } 

        if (this.$store.getters.userRole == "operator") {
          tabs = tabs.filter(item => item.name !== 'Static');
        } 
        
        if (this.isKeyWordType) {
          return tabs.filter(item => item.name !== 'Source');
        } else if (this.isSourceType){
          return tabs.filter(item => item.name !== 'StopSource');
        } else {
          return tabs;
        }
      },
    },
    methods: {
    },
    components: {
      Common,
      ThreadUsers,
      Source,
      StopSource,
      MetaSource,
      Events,
      NavBread,
      Guides,
      Extended,
      Static,
      Logi
    }
  };
</script>

<style>
  .feed-settings-tab {
    padding: 15px 0 15px 0;
  }
    .small-screen{
    display: none;
  }
  @media screen and (max-width: 480px) {
  .el-tabs__nav-wrap{
    display: none;
  }
  .small-screen{
    display: block;
    margin: 5px  25px;
  }
 }
</style>
